import React, { useEffect, useState } from 'react';
import { FaCarAlt, FaShip, FaTruck } from 'react-icons/fa';
import { FaRoadBarrier } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Footer from '../../composant_reutilisable/footer';

const Liste_des_parcs = () => {
    const navigate = useNavigate();

    const [parcs, setParcs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedParc, setSelectedParc] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Récupération des parcs
    const fetchParcs = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                setParcs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchParcs();
    }, []);

    const handleClick = (parc) => {
        setSelectedParc(parc);
        setShowModal(true);
    };

    const handleEcran = (type) => {
        if (!selectedParc) return;

        if (type === "fret") {
            navigate(`/ecrans/${selectedParc.ref_parc}/liste-frets-ecran`);
        } else if (type === "camions") {
            if (selectedParc.type_parc === "national") {
                navigate(`/ecrans/${selectedParc.ref_parc}/Liste-nationaux`);
            } else if (selectedParc.type_parc === "international") {
                navigate(`/ecrans/${selectedParc.ref_parc}/Liste-pays-destination`);
            }
        }

        setShowModal(false);
    };


    return (
        <div
            style={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Titre */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    marginBottom: "30px",
                }}
            >
                <h1
                    style={{
                        fontSize: "32px",
                        fontWeight: "700",
                        color: "#1e293b",
                        letterSpacing: "-0.02em",
                        margin: 0,
                    }}
                >
                    ECRAN
                </h1>
            </div>

            {/* Grille des parcs */}
            {isLoading ? (
                <p style={{ textAlign: "center" }}>Chargement des parcs...</p>
            ) : parcs.length > 0 ? (
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                        gap: "20px",
                        width: "100%",
                        maxWidth: "1400px",
                        margin: "0 auto",
                    }}
                >
                    {parcs.map((parc, index) => (
                        <div
                            key={index}
                            className="card shadow-sm"
                            style={{
                                cursor: "pointer",
                                borderRadius: "12px",
                                padding: "20px",
                                textAlign: "center",
                                background: "#fff",
                                transition: "transform 0.2s, box-shadow 0.2s",
                            }}
                            onClick={() => handleClick(parc)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-5px)";
                                e.currentTarget.style.boxShadow =
                                    "0 8px 16px rgba(0,0,0,0.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                    "0 4px 8px rgba(0,0,0,0.05)";
                            }}
                        >
                            <div className="mb-3">
                                <FaRoadBarrier size={30} className="text-primary" />
                            </div>
                            <h5
                                style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#1e293b",
                                    marginBottom: "5px",
                                }}
                            >
                                {parc.nom_parc}
                            </h5>
                        </div>
                    ))}
                </div>
            ) : (
                <p style={{ textAlign: "center" }}>Aucun parc disponible.</p>
            )}

            {/* Modal */}
            {showModal && selectedParc && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            padding: "20px",
                            maxWidth: "500px",
                            width: "90%",
                            textAlign: "center",
                            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                        }}
                    >
                        <h3 style={{ marginBottom: "10px" }}>
                            Choisissez un écran pour consulter le <br />
                            <strong>{selectedParc.nom_parc}</strong>
                        </h3>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                                gap: "15px",
                                width: "100%",
                            }}
                        >
                            {/* Fret déclaré */}
                            <div
                                className="card shadow-sm"
                                style={{
                                    cursor: "pointer",
                                    borderRadius: "12px",
                                    padding: "15px",
                                    textAlign: "center",
                                    background: "#f0f9ff",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                                onClick={() => handleEcran("fret")}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-3px)";
                                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.1)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.05)";
                                }}
                            >
                                <FaShip size={30} className="text-blue-500 mb-2" />
                                <h5 style={{ fontSize: "16px", fontWeight: "600" }}>Fret déclaré</h5>
                            </div>

                            {/* Camions */}
                            <div
                                className="card shadow-sm"
                                style={{
                                    cursor: "pointer",
                                    borderRadius: "12px",
                                    padding: "15px",
                                    textAlign: "center",
                                    background: "#fef9f0",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                                onClick={() => handleEcran("camions")}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-3px)";
                                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.1)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.05)";
                                }}
                            >
                                <FaTruck size={30} className="text-yellow-500 mb-2" />
                                <h5 style={{ fontSize: "16px", fontWeight: "600" }}>Camions</h5>
                            </div>
                        </div>

                        <button
                            className="btn btn-secondary mt-3"
                            onClick={() => setShowModal(false)}
                        >
                            Annuler
                        </button>
                    </div>

                </div>
            )}

            <div className="footer text-center">
                <Footer />
            </div>
        </div>
    );
};

export default Liste_des_parcs;
